import * as actions from './actions';

const changeCatalogMode = isListMode => dispatch => {
    dispatch(actions.changeCatalogMode(isListMode));
};

export { changeCatalogMode };



// WEBPACK FOOTER //
// ./src/modules/Catalog/actions/operations.js